"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var templateToClass = {
  'trade': 'square',
  'round': 'round',
  'urban': 'round',
  'sleek': 'round',
  'square': 'square',
  'global': 'square',
  'classic': 'round',
  'insider': 'diamond',
  'diamond': 'diamond',
  'professional': 'round'
};

var trim = function trim() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.toString().replace(/^\s+|\s+$/g, '');
};

var BZPersonIcon = function BZPersonIcon(_ref) {
  var _ref$lastName = _ref.lastName,
      lastName = _ref$lastName === void 0 ? '' : _ref$lastName,
      _ref$urlImage = _ref.urlImage,
      urlImage = _ref$urlImage === void 0 ? '' : _ref$urlImage,
      _ref$template = _ref.template,
      template = _ref$template === void 0 ? 'round' : _ref$template,
      _ref$firstName = _ref.firstName,
      firstName = _ref$firstName === void 0 ? '' : _ref$firstName,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$classImage = _ref.classImage,
      classImage = _ref$classImage === void 0 ? '' : _ref$classImage,
      _ref$classHolder = _ref.classHolder,
      classHolder = _ref$classHolder === void 0 ? '' : _ref$classHolder;

  var imageRef = /*#__PURE__*/_react.default.createRef();

  var divRef = /*#__PURE__*/_react.default.createRef();

  var borderOnImage = 'borderOnImage';
  var letters = "".concat(trim(firstName)[0] || '').concat(trim(lastName)[0] || '').toUpperCase();
  var boardImage = templateToClass[template] || 'round';
  var rootClass = (0, _classnames.default)(className, 'image-wrapper', boardImage);
  var holderClass = (0, _classnames.default)(classHolder, 'image-holder', boardImage);
  var imageClass = (0, _classnames.default)(classImage, boardImage);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClass
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: holderClass,
    ref: divRef
  }, urlImage ? /*#__PURE__*/_react.default.createElement("img", {
    src: urlImage,
    ref: imageRef,
    className: imageClass,
    crossOrigin: "anonymous",
    onError: function onError() {
      imageRef.current.src = '/images/agenda/SpeakerIcon.png';
      divRef.current.className = "".concat(borderOnImage, " ").concat(holderClass);
    }
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "letters"
  }, letters)));
};

BZPersonIcon.propTypes = {
  lastName: _propTypes.default.string,
  urlImage: _propTypes.default.string,
  template: _propTypes.default.string,
  firstName: _propTypes.default.string,
  className: _propTypes.default.string,
  classImage: _propTypes.default.string,
  classHolder: _propTypes.default.string
};
var _default = BZPersonIcon;
exports.default = _default;